import { Input, Select } from "antd";
import { Fragment, useRef, useState } from "react";
import "../assets/css/carQuestion.css";
import { useNavigate } from "react-router-dom";

import { carQuestions } from "../utils/data";
const initialValues = {
  drivingMode: "Sports",
  mbti: "INTJ-M",
};
const optionList = [
  {
    value: "Abarth",
    label: "Abarth",
  },
  {
    value: "ACE EV Group",
    label: "ACE EV Group",
  },
  {
    value: "Acura",
    label: "Acura",
  },
  {
    value: "Aeolus",
    label: "Aeolus",
  },
  {
    value: "AeroMobil",
    label: "AeroMobil",
  },
  {
    value: "Agrale",
    label: "Agrale",
  },
  {
    value: "Airstream",
    label: "Airstream",
  },
  {
    value: "Aiways",
    label: "Aiways",
  },
  {
    value: "Aixam",
    label: "Aixam",
  },
  {
    value: "Alfa Romeo",
    label: "Alfa Romeo",
  },
  {
    value: "Alpha Motor Corporation",
    label: "Alpha Motor Corporation",
  },
  {
    value: "Alpina",
    label: "Alpina",
  },
  {
    value: "Alpine",
    label: "Alpine",
  },
  {
    value: "Apollo Automobil",
    label: "Apollo Automobil",
  },
  {
    value: "Aptera",
    label: "Aptera",
  },
  {
    value: "Aquarius Electric",
    label: "Aquarius Electric",
  },
  {
    value: "Arcfox",
    label: "Arcfox",
  },
  {
    value: "Ariel",
    label: "Ariel",
  },
  {
    value: "Arrinera",
    label: "Arrinera",
  },
  {
    value: "Artega",
    label: "Artega",
  },
  {
    value: "Ashok Leyland",
    label: "Ashok Leyland",
  },
  {
    value: "Aspark",
    label: "Aspark",
  },
  {
    value: "Aspark Owl",
    label: "Aspark Owl",
  },
  {
    value: "Aston Martin",
    label: "Aston Martin",
  },
  {
    value: "Audi",
    label: "Audi",
  },
  {
    value: "Aurus Motors",
    label: "Aurus Motors",
  },
  {
    value: "Autech",
    label: "Autech",
  },
  {
    value: "Automobili Estrema",
    label: "Automobili Estrema",
  },
  {
    value: "Automobili Pininfarina",
    label: "Automobili Pininfarina",
  },
  {
    value: "Autosan",
    label: "Autosan",
  },
  {
    value: "Autozam",
    label: "Autozam",
  },
  {
    value: "Avatr",
    label: "Avatr",
  },
  {
    value: "AvtoVAZ",
    label: "AvtoVAZ",
  },
  {
    value: "BAC",
    label: "BAC",
  },
  {
    value: "BAIC Motor",
    label: "BAIC Motor",
  },
  {
    value: "Bajaj Auto",
    label: "Bajaj Auto",
  },
  {
    value: "Baojun",
    label: "Baojun",
  },
  {
    value: "Beijing",
    label: "Beijing",
  },
  {
    value: "Bentley",
    label: "Bentley",
  },
  {
    value: "Bestune",
    label: "Bestune",
  },
  {
    value: "Birkin Cars",
    label: "Birkin Cars",
  },
  {
    value: "Bizzarrini",
    label: "Bizzarrini",
  },
  {
    value: "Blue Bird",
    label: "Blue Bird",
  },
  {
    value: "BMW",
    label: "BMW",
  },
  {
    value: "Bogdan Motors",
    label: "Bogdan Motors",
  },
  {
    value: "Bollinger",
    label: "Bollinger",
  },
  {
    value: "Bolloré",
    label: "Bolloré",
  },
  {
    value: "Bombardier Recreational Products",
    label: "Bombardier Recreational Products",
  },
  {
    value: "Bordrin",
    label: "Bordrin",
  },
  {
    value: "BrightDrop",
    label: "BrightDrop",
  },
  {
    value: "Bugatti",
    label: "Bugatti",
  },
  {
    value: "Buick",
    label: "Buick",
  },
  {
    value: "BYD Auto",
    label: "BYD Auto",
  },
  {
    value: "BYTON",
    label: "BYTON",
  },
  {
    value: "Cadillac",
    label: "Cadillac",
  },
  {
    value: "CAIO Induscar",
    label: "CAIO Induscar",
  },
  {
    value: "Campagna Motors",
    label: "Campagna Motors",
  },
  {
    value: "Canoo",
    label: "Canoo",
  },
  {
    value: "Carver",
    label: "Carver",
  },
  {
    value: "Caterham",
    label: "Caterham",
  },
  {
    value: "Cenntro Automotive",
    label: "Cenntro Automotive",
  },
  {
    value: "Changan Automobile",
    label: "Changan Automobile",
  },
  {
    value: "Chery",
    label: "Chery",
  },
  {
    value: "Chevrolet",
    label: "Chevrolet",
  },
  {
    value: "Chrysler",
    label: "Chrysler",
  },
  {
    value: "Citroën",
    label: "Citroën",
  },
  {
    value: "CT&T",
    label: "CT&T",
  },
  {
    value: "Cupra",
    label: "Cupra",
  },
  {
    value: "Dacia",
    label: "Dacia",
  },
  {
    value: "Daewoo Bus",
    label: "Daewoo Bus",
  },
  {
    value: "DAF Trucks",
    label: "DAF Trucks",
  },
  {
    value: "Daihatsu",
    label: "Daihatsu",
  },
  {
    value: "Dallara",
    label: "Dallara",
  },
  {
    value: "Daymak",
    label: "Daymak",
  },
  {
    value: "Delage",
    label: "Delage",
  },
  {
    value: "DeLorean Motor Company",
    label: "DeLorean Motor Company",
  },
  {
    value: "Denza",
    label: "Denza",
  },
  {
    value: "Devon Motorworks",
    label: "Devon Motorworks",
  },
  {
    value: "DFSK",
    label: "DFSK",
  },
  {
    value: "Dodge",
    label: "Dodge",
  },
  {
    value: "Dongfeng Motor",
    label: "Dongfeng Motor",
  },
  {
    value: "Donkervoort",
    label: "Donkervoort",
  },
  {
    value: "DR Automobiles",
    label: "DR Automobiles",
  },
  {
    value: "Drako Motors",
    label: "Drako Motors",
  },
  {
    value: "DS Automobiles",
    label: "DS Automobiles",
  },
  {
    value: "e.Go Mobile",
    label: "e.Go Mobile",
  },
  {
    value: "Ebro Electric Trucks",
    label: "Ebro Electric Trucks",
  },
  {
    value: "Edag Citybot",
    label: "Edag Citybot",
  },
  {
    value: "Edison Motors",
    label: "Edison Motors",
  },
  {
    value: "Eicher Motors",
    label: "Eicher Motors",
  },
  {
    value: "Electra Meccanica",
    label: "Electra Meccanica",
  },
  {
    value: "Elfin",
    label: "Elfin",
  },
  {
    value: "EMC Endurance",
    label: "EMC Endurance",
  },
  {
    value: "Enovate Motors",
    label: "Enovate Motors",
  },
  {
    value: "Evergrande NEVS",
    label: "Evergrande NEVS",
  },
  {
    value: "Everus",
    label: "Everus",
  },
  {
    value: "Exeed",
    label: "Exeed",
  },
  {
    value: "Faraday Future",
    label: "Faraday Future",
  },
  {
    value: "Felino",
    label: "Felino",
  },
  {
    value: "Ferrari",
    label: "Ferrari",
  },
  {
    value: "Fiat",
    label: "Fiat",
  },
  {
    value: "Fisker",
    label: "Fisker",
  },
  {
    value: "Force Motors",
    label: "Force Motors",
  },
  {
    value: "Ford",
    label: "Ford",
  },
  {
    value: "Foton",
    label: "Foton",
  },
  {
    value: "Freightliner",
    label: "Freightliner",
  },
  {
    value: "Fresco Motors",
    label: "Fresco Motors",
  },
  {
    value: "GAC Motor",
    label: "GAC Motor",
  },
  {
    value: "GAZ",
    label: "GAZ",
  },
  {
    value: "Geely Auto",
    label: "Geely Auto",
  },
  {
    value: "Genesis",
    label: "Genesis",
  },
  {
    value: "Geometry",
    label: "Geometry",
  },
  {
    value: "Ghabbour Auto",
    label: "Ghabbour Auto",
  },
  {
    value: "Gillig",
    label: "Gillig",
  },
  {
    value: "Ginetta",
    label: "Ginetta",
  },
  {
    value: "GLM",
    label: "GLM",
  },
  {
    value: "GMC",
    label: "GMC",
  },
  {
    value: "Gordon Murray Automotive",
    label: "Gordon Murray Automotive",
  },
  {
    value: "Great Wall Motors",
    label: "Great Wall Motors",
  },
  {
    value: "GreenPower Motor Company",
    label: "GreenPower Motor Company",
  },
  {
    value: "Haima",
    label: "Haima",
  },
  {
    value: "Haval",
    label: "Haval",
  },
  {
    value: "Hennessey",
    label: "Hennessey",
  },
  {
    value: "Hino",
    label: "Hino",
  },
  {
    value: "HiPhi",
    label: "HiPhi",
  },
  {
    value: "Hispano Suiza Cars",
    label: "Hispano Suiza Cars",
  },
  {
    value: "Honda",
    label: "Honda",
  },
  {
    value: "Hongqi",
    label: "Hongqi",
  },
  {
    value: "Hopium",
    label: "Hopium",
  },
  {
    value: "Hozon Auto",
    label: "Hozon Auto",
  },
  {
    value: "HSV",
    label: "HSV",
  },
  {
    value: "Hyundai",
    label: "Hyundai",
  },
  {
    value: "Icon Electric Vehicles",
    label: "Icon Electric Vehicles",
  },
  {
    value: "IKCO",
    label: "IKCO",
  },
  {
    value: "IM Motors",
    label: "IM Motors",
  },
  {
    value: "INDI EV",
    label: "INDI EV",
  },
  {
    value: "INEOS Automotive",
    label: "INEOS Automotive",
  },
  {
    value: "Infiniti",
    label: "Infiniti",
  },
  {
    value: "Innoson Vehicle Manufacturing",
    label: "Innoson Vehicle Manufacturing",
  },
  {
    value: "International",
    label: "International",
  },
  {
    value: "Irizar",
    label: "Irizar",
  },
  {
    value: "Isuzu",
    label: "Isuzu",
  },
  {
    value: "Iveco",
    label: "Iveco",
  },
  {
    value: "JAC Motors",
    label: "JAC Motors",
  },
  {
    value: "Jaguar",
    label: "Jaguar",
  },
  {
    value: "Jeep",
    label: "Jeep",
  },
  {
    value: "Jetour",
    label: "Jetour",
  },
  {
    value: "Jiangling Motors",
    label: "Jiangling Motors",
  },
  {
    value: "Joby Aviation",
    label: "Joby Aviation",
  },
  {
    value: "Kamaz",
    label: "Kamaz",
  },
  {
    value: "Kantanka",
    label: "Kantanka",
  },
  {
    value: "Karma",
    label: "Karma",
  },
  {
    value: "Karsan",
    label: "Karsan",
  },
  {
    value: "Kenworth",
    label: "Kenworth",
  },
  {
    value: "Kerman Khodro",
    label: "Kerman Khodro",
  },
  {
    value: "KG Mobility",
    label: "KG Mobility",
  },
  {
    value: "Kia",
    label: "Kia",
  },
  {
    value: "Kiira Motors",
    label: "Kiira Motors",
  },
  {
    value: "Koenigsegg",
    label: "Koenigsegg",
  },
  {
    value: "KTM",
    label: "KTM",
  },
  {
    value: "Kyburz",
    label: "Kyburz",
  },
  {
    value: "Lada",
    label: "Lada",
  },
  {
    value: "Lamborghini",
    label: "Lamborghini",
  },
  {
    value: "Lancia",
    label: "Lancia",
  },
  {
    value: "Land Rover",
    label: "Land Rover",
  },
  {
    value: "Laraki",
    label: "Laraki",
  },
  {
    value: "Leapmotor",
    label: "Leapmotor",
  },
  {
    value: "Leapmotor C11",
    label: "Leapmotor C11",
  },
  {
    value: "LEVC",
    label: "LEVC",
  },
  {
    value: "Lexus",
    label: "Lexus",
  },
  {
    value: "Li Auto",
    label: "Li Auto",
  },
  {
    value: "Lightyear",
    label: "Lightyear",
  },
  {
    value: "Ligier",
    label: "Ligier",
  },
  {
    value: "Lincoln",
    label: "Lincoln",
  },
  {
    value: "Lion Electric",
    label: "Lion Electric",
  },
  {
    value: "Lordstown Motors",
    label: "Lordstown Motors",
  },
  {
    value: "Lotus",
    label: "Lotus",
  },
  {
    value: "Lucid",
    label: "Lucid",
  },
  {
    value: "Lucid Motors",
    label: "Lucid Motors",
  },
  {
    value: "Lynk & Co",
    label: "Lynk & Co",
  },
  {
    value: "Mack Trucks",
    label: "Mack Trucks",
  },
  {
    value: "Mahindra",
    label: "Mahindra",
  },
  {
    value: "MAN",
    label: "MAN",
  },
  {
    value: "Marcopolo",
    label: "Marcopolo",
  },
  {
    value: "Maruti Suzuki",
    label: "Maruti Suzuki",
  },
  {
    value: "Maserati",
    label: "Maserati",
  },
  {
    value: "Mastretta",
    label: "Mastretta",
  },
  {
    value: "Maxus",
    label: "Maxus",
  },
  {
    value: "Maybach",
    label: "Maybach",
  },
  {
    value: "MAZ",
    label: "MAZ",
  },
  {
    value: "Mazda",
    label: "Mazda",
  },
  {
    value: "Mazzanti",
    label: "Mazzanti",
  },
  {
    value: "McLaren",
    label: "McLaren",
  },
  {
    value: "Mercedes-Benz",
    label: "Mercedes-Benz",
  },
  {
    value: "MG Motor",
    label: "MG Motor",
  },
  {
    value: "Micro Mobility Systems",
    label: "Micro Mobility Systems",
  },
  {
    value: "Microcar",
    label: "Microcar",
  },
  {
    value: "Microcar Due",
    label: "Microcar Due",
  },
  {
    value: "Mini",
    label: "Mini",
  },
  {
    value: "Mitsubishi Motors",
    label: "Mitsubishi Motors",
  },
  {
    value: "Mobius Motors",
    label: "Mobius Motors",
  },
  {
    value: "Morgan",
    label: "Morgan",
  },
  {
    value: "Mullen Automotive",
    label: "Mullen Automotive",
  },
  {
    value: "Neobus",
    label: "Neobus",
  },
  {
    value: "New Flyer",
    label: "New Flyer",
  },
  {
    value: "Nikola",
    label: "Nikola",
  },
  {
    value: "Nikola Badger",
    label: "Nikola Badger",
  },
  {
    value: "Nikola Tre",
    label: "Nikola Tre",
  },
  {
    value: "NIO",
    label: "NIO",
  },
  {
    value: "Nissan",
    label: "Nissan",
  },
  {
    value: "Noble",
    label: "Noble",
  },
  {
    value: "Nxu",
    label: "Nxu",
  },
  {
    value: "Obvio!",
    label: "Obvio!",
  },
  {
    value: "Ola Electric",
    label: "Ola Electric",
  },
  {
    value: "Olectra Greentech",
    label: "Olectra Greentech",
  },
  {
    value: "Opel",
    label: "Opel",
  },
  {
    value: "Ora",
    label: "Ora",
  },
  {
    value: "Oshan",
    label: "Oshan",
  },
  {
    value: "Oshkosh",
    label: "Oshkosh",
  },
  {
    value: "PACCAR",
    label: "PACCAR",
  },
  {
    value: "Pagani",
    label: "Pagani",
  },
  {
    value: "PAL-V",
    label: "PAL-V",
  },
  {
    value: "Panhard",
    label: "Panhard",
  },
  {
    value: "Paramount Group",
    label: "Paramount Group",
  },
  {
    value: "Pars Khodro",
    label: "Pars Khodro",
  },
  {
    value: "Perodua",
    label: "Perodua",
  },
  {
    value: "Peterbilt",
    label: "Peterbilt",
  },
  {
    value: "Peugeot",
    label: "Peugeot",
  },
  {
    value: "Piaggio",
    label: "Piaggio",
  },
  {
    value: "Piëch Automotive",
    label: "Piëch Automotive",
  },
  {
    value: "Polaris",
    label: "Polaris",
  },
  {
    value: "Polestar",
    label: "Polestar",
  },
  {
    value: "Porsche",
    label: "Porsche",
  },
  {
    value: "Praga",
    label: "Praga",
  },
  {
    value: "Prodrive",
    label: "Prodrive",
  },
  {
    value: "Proterra",
    label: "Proterra",
  },
  {
    value: "Proton",
    label: "Proton",
  },
  {
    value: "Qiantu Motor",
    label: "Qiantu Motor",
  },
  {
    value: "Radical",
    label: "Radical",
  },
  {
    value: "Ram",
    label: "Ram",
  },
  {
    value: "REE Automotive",
    label: "REE Automotive",
  },
  {
    value: "Renault",
    label: "Renault",
  },
  {
    value: "Renault Korea Motors",
    label: "Renault Korea Motors",
  },
  {
    value: "Rezvani",
    label: "Rezvani",
  },
  {
    value: "Rimac Automobili",
    label: "Rimac Automobili",
  },
  {
    value: "Rinspeed",
    label: "Rinspeed",
  },
  {
    value: "Riversimple",
    label: "Riversimple",
  },
  {
    value: "Rivian",
    label: "Rivian",
  },
  {
    value: "Roewe",
    label: "Roewe",
  },
  {
    value: "Rolls-Royce Motor Cars",
    label: "Rolls-Royce Motor Cars",
  },
  {
    value: "RUF Automobile",
    label: "RUF Automobile",
  },
  {
    value: "SAIC Motor",
    label: "SAIC Motor",
  },
  {
    value: "SAIPA",
    label: "SAIPA",
  },
  {
    value: "Saleen",
    label: "Saleen",
  },
  {
    value: "Sandstorm Automotive",
    label: "Sandstorm Automotive",
  },
  {
    value: "Saroukh Motors",
    label: "Saroukh Motors",
  },
  {
    value: "Sbarro",
    label: "Sbarro",
  },
  {
    value: "Scania",
    label: "Scania",
  },
  {
    value: "SEAT",
    label: "SEAT",
  },
  {
    value: "Sehol",
    label: "Sehol",
  },
  {
    value: "Seres",
    label: "Seres",
  },
  {
    value: "Shenzhen BYD Daimler New Technology",
    label: "Shenzhen BYD Daimler New Technology",
  },
  {
    value: "Singulato Motors",
    label: "Singulato Motors",
  },
  {
    value: "Sitech Dev.",
    label: "Sitech Dev.",
  },
  {
    value: "Skoda",
    label: "Skoda",
  },
  {
    value: "Skyworth Auto",
    label: "Skyworth Auto",
  },
  {
    value: "Smart",
    label: "Smart",
  },
  {
    value: "Solaris Bus & Coach",
    label: "Solaris Bus & Coach",
  },
  {
    value: "Solbus",
    label: "Solbus",
  },
  {
    value: "Sono Motors",
    label: "Sono Motors",
  },
  {
    value: "SP Automotive",
    label: "SP Automotive",
  },
  {
    value: "Spartan Motors",
    label: "Spartan Motors",
  },
  {
    value: "Spyker",
    label: "Spyker",
  },
  {
    value: "SSC North America",
    label: "SSC North America",
  },
  {
    value: "Streetscooter",
    label: "Streetscooter",
  },
  {
    value: "Subaru",
    label: "Subaru",
  },
  {
    value: "Suzuki",
    label: "Suzuki",
  },
  {
    value: "Tank",
    label: "Tank",
  },
  {
    value: "Tata Motors",
    label: "Tata Motors",
  },
  {
    value: "Tatra",
    label: "Tatra",
  },
  {
    value: "Tauro Sport Auto",
    label: "Tauro Sport Auto",
  },
  {
    value: "Techrules",
    label: "Techrules",
  },
  {
    value: "Terrafugia",
    label: "Terrafugia",
  },
  {
    value: "Tesla",
    label: "Tesla",
  },
  {
    value: "Think Car Norway",
    label: "Think Car Norway",
  },
  {
    value: "Togg",
    label: "Togg",
  },
  {
    value: "Torsus",
    label: "Torsus",
  },
  {
    value: "Toyota",
    label: "Toyota",
  },
  {
    value: "Tramontana",
    label: "Tramontana",
  },
  {
    value: "Troller",
    label: "Troller",
  },
  {
    value: "TVR",
    label: "TVR",
  },
  {
    value: "UAZ",
    label: "UAZ",
  },
  {
    value: "UD Trucks",
    label: "UD Trucks",
  },
  {
    value: "Ultima Sports",
    label: "Ultima Sports",
  },
  {
    value: "Valmet Automotive",
    label: "Valmet Automotive",
  },
  {
    value: "Venturi",
    label: "Venturi",
  },
  {
    value: "Venturi Antarctica",
    label: "Venturi Antarctica",
  },
  {
    value: "VIA Motors",
    label: "VIA Motors",
  },
  {
    value: "VinFast",
    label: "VinFast",
  },
  {
    value: "Volkswagen",
    label: "Volkswagen",
  },
  {
    value: "Volocopter",
    label: "Volocopter",
  },
  {
    value: "Volvo",
    label: "Volvo",
  },
  {
    value: "Voyah",
    label: "Voyah",
  },
  {
    value: "VUHL",
    label: "VUHL",
  },
  {
    value: "W Motors",
    label: "W Motors",
  },
  {
    value: "Walkinshaw Automotive",
    label: "Walkinshaw Automotive",
  },
  {
    value: "Western Star",
    label: "Western Star",
  },
  {
    value: "Wey",
    label: "Wey",
  },
  {
    value: "Wiesmann",
    label: "Wiesmann",
  },
  {
    value: "Winnebago",
    label: "Winnebago",
  },
  {
    value: "WM Motor",
    label: "WM Motor",
  },
  {
    value: "Workhorse Group",
    label: "Workhorse Group",
  },
  {
    value: "Wuling",
    label: "Wuling",
  },
  {
    value: "XPeng",
    label: "XPeng",
  },
  {
    value: "Yangwang",
    label: "Yangwang",
  },
  {
    value: "Zacua",
    label: "Zacua",
  },
  {
    value: "Zarooq Motors",
    label: "Zarooq Motors",
  },
  {
    value: "ZAZ",
    label: "ZAZ",
  },
  {
    value: "Zeekr",
    label: "Zeekr",
  },
  {
    value: "Zenvo",
    label: "Zenvo",
  },
  {
    value: "Zotye",
    label: "Zotye",
  },
];

const yearOptions = Array.from({ length: 2025 - 1980 + 1 }, (_, i) => {
  const year = 2025 - i;
  return { value: year.toString(), label: year.toString() };
});

carQuestions.forEach((question) => {
  initialValues[question.id] = "";
});

const CarQuestionForm = (props) => {
  const [answer, setAnswer] = useState(initialValues);
  const navigate = useNavigate();
  const [mileageError, setMileageError] = useState("");
  

  const handleChange = (value) => {
    setAnswer((prevState) => {
      return {
        ...prevState,
        drivingMode: value,
      };
    });
  };
  const handleCarChange = (value) => {
    setAnswer((prevState) => {
      return {
        ...prevState,
        brand: value,
      };
    });
  };

  const handleNext = () => {
    if (!answer) return;
    navigate("/personas", {
      state: { answer, epuid: props.epuId, secret: props.secret },
    });
  };

  // const handleSubmit = async () => {
  //   setLoading(true);
  //   try {
  //     let generateimageResponse = await axios.post(
  //       `${process.env.REACT_APP_END_POINT}/get_carimage`,
  //       {
  //         answer: answer,
  //         epuid: props.epuId,
  //       }
  //     );
  //     console.log("generateimageResponse", generateimageResponse);
  //     let personalityResponse = await axios.post(
  //       `${process.env.REACT_APP_END_POINT}/get_personality`,
  //       {
  //         epuid: props.epuId,
  //         secret: props.secret,
  //         answer: answer,
  //         avatar: generateimageResponse.data.data,
  //       }
  //     );
  //     // if (personalityResponse.status === 200) {
  //     //   window.open(
  //     //     `https://metasoul.live/soulViewer.min.html?secret=${props.secret}&epuId=${props.epuId.epuid}&persona=${answer.drivingMode}`,
  //     //     "_self"
  //     //   );
  //     //   setAnswer(initialValues);
  //     // }
  //     if (personalityResponse.status === 200) {
  //       window.open(
  //         `http://127.0.0.1:5501/metasoul-espark/soulViewer.min.html?secret=${props.secret}&epuId=${props.epuId.epuid}&persona=${answer.drivingMode}`,
  //         "_self"
  //       );
  //       setAnswer(initialValues);
  //       console.log("answer", answer);
  //     }
  //   } catch (error) {
  //     console.error("Submission error:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  return (
    <div className="carQuestionContainer">
      <Fragment>
        {carQuestions?.map((carQue) => (
          <div className="formControl" key={carQue.id}>
            <p>{carQue.que}</p>
            {/* {carQue.type == "select" ? (
              <Select
                showSearch
                className="selectBox"
                dropdownStyle={{
                  borderRadius: "20px",
                  paddingTop: "5px",
                  paddingBottom: "5px",
                }}
                filterOption={(input, option) =>
                  option.label.toLowerCase().startsWith(input.toLowerCase())
                }
                onChange={handleCarChange}
                options={optionList}
              />
            ) : (
              <Input
                placeholder={carQue.plc}
                className="formInput"
                value={answer[carQue.id]}
                onChange={(e) => {
                  setAnswer((prevState) => {
                    const newState = { ...prevState };
                    newState[carQue.id] = e.target.value;
                    return newState;
                  });
                }}
              />
            )} */}
            {carQue.id === "brand" ? (
              <Select
                showSearch
                className="selectBox"
                dropdownStyle={{
                  borderRadius: "20px",
                  paddingTop: "5px",
                  paddingBottom: "5px",
                }}
                filterOption={(input, option) =>
                  option.label.toLowerCase().startsWith(input.toLowerCase())
                }
                onChange={handleCarChange}
                options={optionList}
              />
            ) : carQue.id === "year" ? (
              <Select
                showSearch
                className="selectBox"
                dropdownStyle={{
                  borderRadius: "20px",
                  paddingTop: "5px",
                  paddingBottom: "5px",
                }}
                placeholder="Select Year"
                onChange={(value) =>
                  setAnswer((prev) => ({
                    ...prev,
                    year: value,
                  }))
                }
                filterOption={(input, option) =>
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={yearOptions}
              />
            ) : carQue.id === "mileage" ? (
              <>
                <Input
                  placeholder={carQue.plc}
                  className="formInput"
                  value={answer[carQue.id]}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d*$/.test(value)) {
                      setMileageError(""); // clear error
                      setAnswer((prevState) => ({
                        ...prevState,
                        [carQue.id]: value,
                      }));
                    } else {
                      setMileageError("Only numbers are allowed");
                    }
                  }}
                />
                {mileageError && (
                  <p style={{ color: "red", marginTop: "4px" }}>
                    {mileageError}
                  </p>
                )}
              </>
            ) : (
              <Input
                placeholder={carQue.plc}
                className="formInput"
                value={answer[carQue.id]}
                onChange={(e) => {
                  setAnswer((prevState) => {
                    const newState = { ...prevState };
                    newState[carQue.id] = e.target.value;
                    return newState;
                  });
                }}
              />
            )}
          </div>
        ))}

        <div className="formControl">
          <p>Which driving mode do you prefer?</p>
          <Select
            defaultValue={initialValues.drivingMode}
            className="selectBox"
            dropdownStyle={{
              borderRadius: "20px",
              paddingTop: "5px",
              paddingBottom: "5px",
            }}
            onChange={handleChange}
            options={[
              { value: "Sports", label: "Sports" },
              { value: "Comfort", label: "Comfort" },
              { value: "Economy", label: "Economy" },
            ]}
          />
        </div>

        {/* <div className="formControl">
          <p>What personality would you like your car to have?</p>

          <div className="grid">
            {personalityOptions.map((option) => (
              <figure
                key={option.value}
                className={`card ${
                  selected === option.value ? "selected" : ""
                }`}
                tabIndex={0}
                onMouseEnter={() => handleMouseEnter(option)}
                onMouseLeave={() => handleMouseLeave(option)}
                onClick={() => handleSelect(option)}
              >
                <img src={option.image} alt={option.name} />
                <figcaption>
                  <div className="name">{option.name}</div>
                  <div className="hint">Hover or tap to hear</div>
                </figcaption>
                <audio
                  ref={(el) => (audioRefs.current[option.value] = el)}
                  preload="auto"
                  playsInline
                  src={option.audio}
                />
              </figure>
            ))}
          </div>
        </div> */}
        {/* <button className="nextBtn" onClick={handleSubmit}>
          Submit
        </button> */}

        <button className="nextBtn" onClick={handleNext}>
          Next
        </button>

        {/* <button className="nextBtn" disabled={loading} onClick={handleSubmit}>
          {loading ? (
            <Spin size="small" style={{ color: "white" }} />
          ) : (
            "Submit"
          )}
        </button> */}
      </Fragment>
      {/* {!isGeolocationAvailable && <h2>Location API not supported</h2>} */}
      {/* {!isGeolocationEnabled && <Fragment>
            <h2>Location Permission not granted!</h2>
            <p>This part of website requires your overall location information (Country and State). So allow this website to get permission from browser settings and after granting the permission, click on "Get Location" button. or Input Your Location manually.</p>
            <button className={classes.nextBtn}>Get Location</button>
            <button className={classes.nextBtn}>Input Location Manually</button>
        </Fragment>} */}
    </div>
  );
};

export default CarQuestionForm;
